import React, { useEffect, useState } from "react";
import FinQBanner from "./FinQBanner/FinQBanner";
import FinQSection from "./FinQSection/FinQSection";
// import FinQSectionNew from './FinQSectionNew/FinQSectionNew';
import URLstateContext from "../../provider/CommonContext";
function FinQ() {
  return (
    <>

      <main id="main-content" tabIndex="-1">
      <FinQBanner />
        <FinQSection />
      </main>
      {/* <FinQSectionNew/> */}
    </>
  );
}

export default FinQ;
